<template>
  <div class="main">
    <Header 
      :show="true"
      title="消息推送"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        wrapable
        :scrollable="false"
        left-icon="info-o"
        text="请配置各消息所要推送的人群，留空则表示不推送"
      />
      <van-card
        v-for="item in table.data"
        :key="item.id"
        :title="item.id + '. ' + item.name"
      >
        <template #tags>
          <van-tag 
            plain 
            type="success"
            v-for="member in item.members"
            :key="member.serial"
          >
            {{ member.name }}
          </van-tag>
        </template>
        <template #num>
          <el-button v-if="checkPermission([112])" type="primary" size="mini" @click="handleClickUpdate(item)">
            编辑
          </el-button>
          <el-button v-else type="primary" size="mini" disabled>
            编辑
          </el-button>
        </template>
      </van-card>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>

  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { getList, updateOne } from '@/api/message.js'
  import { getList as getStaffList } from '@/api/staff.js'

  export default {
    name: "ServiceProjectMessage",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        listQuery: {
          limit: 10,
          page: 1
        },
        isLoading: false,
        members: [0, [], [], [], [], [], [], [], [], []],
        table: {
          listLoading: false,
          height: document.documentElement.clientHeight-340,
          key: 0,
          total: 0,
          data: []
        },
        staffOptions: []
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      this.handleGetStaffList()
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$router.push({ 
          path:'/service/project/message/update', 
          query: {} ,
        })
      },
      handleGetStaffList() {
        const data = {
          page: 1,
          limit: 10000
        }
        getStaffList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.staffOptions = []
            for (let i=0; i<items.length; i++) {
              if (items[i].wxwork !== '') {
                this.staffOptions.push({
                  id: items[i].id,
                  label: items[i].name,
                  value: items[i].wxwork
                })
              }
            }
            this.handleClickQuery()
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleClickQuery() {
        const data = {
          page: this.listQuery.page,
          limit: this.listQuery.limit
        }
        getList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data
            this.table.data = []
            let s = 1
            for (let i=0; i<items.length; i++) {
              if (items[i].type === '消息推送') {
                let arrName = []
                const arrWxwork = items[i].value.split('|')
                for (let j=0; j<arrWxwork.length; j++) {
                  for (let k=0; k<this.staffOptions.length; k++) {
                    if (arrWxwork[j] === this.staffOptions[k].value) {
                      arrName.push({
                        serial: this.staffOptions[k].id,
                        wxwork: this.staffOptions[k].value,
                        name: this.staffOptions[k].label
                      })
                    }
                  }
                }
                this.table.data.push({
                  id: s++,
                  serial: items[i].id,
                  name: items[i].name,
                  members: arrName,
                  remark: items[i].remark
                })
              }
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleClickUpdate(row) {
        let serialList = []
        for (let i=0; i<row.members.length; i++) {
          serialList.push(row.members[i].serial)
        }
        this.$router.push({ 
          path:'/service/project/message/update', 
          query: {
            serial: row.serial,
            name: row.name,
            members: serialList.join("|"),
            remark: row.remark
          },
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  // 系统样式修改
  ::v-deep .van-card {
    font-size: 16px;
  }
  ::v-deep .van-tag {
    padding: 3px 5px;
    margin: 5px 3px;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
